import { BefreiungErgebnis } from './../entities/befreiungErgebnis';
import { Einwilligung } from '../einwilligung';

export abstract class AbstractBefreiungService {
  abstract getBefreiung(kvNummer: string, einwilligung: Einwilligung): Promise<BefreiungErgebnis>;
}



// WEBPACK FOOTER //
// ./src/app/befreiung/shared/services/abstract-befreiung.service.ts